module.exports = __webpack_public_path__ + "img/online.1fd422da.svg";